(function () {
    // ----------------------
    // Funcionalidad 1: Alternar clase "active" y ajustar altura de .text
    // ----------------------
    const elements = document.querySelectorAll(
      '.new-collection-section .collection-section .title-and-paragraph .paragraph'
    );

    let vetReviewedContainer = document.querySelector(
      '.new-collection-section .collection-section .vet-reviewed-container'
    );

    elements.forEach((element) => {
      element.addEventListener('click', function () {
        element.classList.toggle('active');
        const textElement = element.querySelector('.text');
        if (textElement) {
          if (element.classList.contains('active')) {
            textElement.style.height = `${textElement.scrollHeight}px`; // Expandimos
          } else {
            textElement.style.height = '24px'; // Contraemos
          }
        }

        if (vetReviewedContainer) {
          if (element.classList.contains('active')) {
            // Flecha hacia arriba: ocultamos el bloque
            vetReviewedContainer.style.display = 'none';
          } else {
            // Flecha hacia abajo: mostramos siempre el bloque
            vetReviewedContainer.style.display = 'block';
          }
        }
      });
    });

    // ----------------------
    // Funcionalidad 2: Abrir y cerrar modal
    // ----------------------
    const openFilterButton = document.querySelector(
      '.new-collection-section .collection-section .open-filter-mobile .open-filter-mobile-container .open-filter'
    );
    const darkBackground = document.querySelector('.new-collection-section .dark-background');
    const filtersCollection = document.querySelector('.new-collection-section .filters-collection');
    const closeButton = document.querySelector('.new-collection-section .filters-collection .closse-button');
  
    if (openFilterButton && darkBackground && filtersCollection && closeButton) {
      // Abrir modal
      openFilterButton.addEventListener('click', function () {
        darkBackground.classList.add('active'); // Activa fondo oscuro
        filtersCollection.classList.add('active'); // Activa el modal
      });
  
      // Cerrar modal
      closeButton.addEventListener('click', function () {
        darkBackground.classList.remove('active'); // Quita la clase del fondo oscuro
        filtersCollection.classList.remove('active'); // Quita la clase del modal
      });
    }
})();
  